module.exports = "/settings/components/editShiftTemplate/editShiftTemplate-f98a22.html";